import { useEffect, useState } from 'react';
import { getIndexedDBItem } from '../modules/utils/IndexedDB';

const useIndexDBValue = <T extends object>({ key }: { key: string }) => {
	const [value, setValue] = useState<T>();

	useEffect(() => {
		getIndexDBValueByKey(key);
	}, []);

	const getIndexDBValueByKey = async (key: string) => {
		try {
			const dbValue: T = await getIndexedDBItem(key);
			setValue(dbValue);
		} catch (error) {
			console.error(error);
		}
	};

	return {
		value,
	};
};

export default useIndexDBValue;
